import React from 'react';

interface PDFPreviewCoverProps {
  thumbnailUrl: string;
  title: string;
  onPdfDownload: () => void;
}

export const PDFPreviewCover: React.FC<PDFPreviewCoverProps> = ({
  thumbnailUrl,
  title,
  onPdfDownload,
}) => {
  return (
    <div
      style={{
        position: 'relative',
        height: '260px',
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          width: '264px',
          height: '100%',
          overflow: 'hidden',
          position: 'relative',
        }}
      >
        <img src={thumbnailUrl} width={264} />
      </div>

      <div
        onClick={onPdfDownload}
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'transparent',
          cursor: 'pointer',
          zIndex: 10,
        }}
      />

      <div
        style={{
          position: 'absolute',
          top: '16px',
          right: '16px',
          backgroundColor: '#ff4d4f',
          color: 'white',
          padding: '4px 12px',
          borderRadius: '4px',
          transform: 'rotate(12deg)',
          opacity: 0.8,
          fontWeight: 600,
          fontSize: '14px',
          pointerEvents: 'none',
        }}
      >
        Sample
      </div>
    </div>
  );
};
